module.exports = __webpack_public_path__ + "img/ant.b3fe9951.svg";